import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from './auth/auth.service';
import { HeaderComponent } from './components/header';
import { FooterComponent } from './components/footer';
import { ErrorNotificationsComponent } from './shared/components/error-notifications/error-notifications.component';

@Component({
  selector: 'app-root',
  template: `
    <!-- Global header with user profile and session monitor -->
    <app-header></app-header>
    
    <!-- Main application content -->
    <main class="app-content">
      <router-outlet></router-outlet>
    </main>
    
    <!-- Global footer with version info -->
    <app-footer></app-footer>
    
    <!-- Global error notifications -->
    <app-error-notifications></app-error-notifications>
  `,
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, FooterComponent, ErrorNotificationsComponent]
})
export class AppComponent implements OnInit {
  constructor(
    public authService: AuthService
  ) {
    console.log('AppComponent initialized');
  }

  ngOnInit() {
    console.log('AppComponent.ngOnInit called');
    
    // Process magic link token immediately if present in URL
    // This ensures token is processed before any navigation or page refresh
    this.authService.validateTokenFromUrl();
  }
}